import React, { useEffect, useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import { loadDateRange, addBgOnIframe } from '@revbox/helpers-fe'
import { mixpanelInstance } from '../../mixpanel/instance'
import '../loader.css'
import CampaignImpressionsAndClicks from '../../adv/campaign/campaign/CampaignImpressionsAndClicks'
import { useCookiesContext } from '../../contexts/CookiesContext'
import { addDays, endOfDay, startOfDay } from 'date-fns'

export default function ImpressionsAndClicksIframe() {
    const { cookiesData, getPathKey } = useCookiesContext()
    const [iframe, setIframe] = useState(null)
    const [campaignId, setCampaignId] = useState(null)
    const [currentPeriod, setCurrentPeriod] = useState(null)

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search)
        const campaignId = urlParams.get('campaignId')
        const token = urlParams.get('token')
        const store = cookiesData[getPathKey()]
        const { currentPeriod } = loadDateRange(token, store, startOfDay, endOfDay, addDays, 29)
        if (currentPeriod) {
            setCurrentPeriod(currentPeriod)
        }
        setCampaignId(campaignId)
        mixpanelInstance.track('Impressions and Clicks Page Loaded')
        addBgOnIframe();
        setIframe(1)
    }, [])

    if (iframe === 1) {
        return (
            <Row 
                className="g-3 iframe-background htr-iframe-bg" 
                style={
                    {width: '100%', 
                    margin: '0 auto', 
                }}
                >
                <Col md="12" xl="12" className="iframe-card-wrap p-0 m-0">
                    <Card className="card-one iframe-card-background">
                        <CampaignImpressionsAndClicks 
                            currentPeriod={currentPeriod} 
                            campaignId={campaignId} 
                            isIframe={true} 
                        />
                    </Card>
                </Col>
            </Row>
        )
    } else {
        return (
            <div>
                <span className="loader"></span>
            </div>
        )
    }
}
